import { ModalCssClassEnum } from '@core/enums';
import { mapMenuItemProduct } from '@core/helpers';
import { getPrimaryProductChannel } from '../../util';
import {
	HomeMenuItemModalRule,
	HomeMenuItemProcessingRule,
	HomeQuantityChangeRule,
} from '../interfaces';

export const homeMenuItemProductRule: HomeMenuItemProcessingRule = context => ({
	...context,
	viewState: {
		...context.viewState,
		...mapMenuItemProduct(context.item),
	},
});

export const homeMenuItemPricingRule: HomeMenuItemProcessingRule = context => {
	const priceOption = getPrimaryProductChannel(context.item)?.precios?.[0];
	const price = BigInt(context.item?.precio ?? priceOption?.precio ?? 0n);
	const specialPriceAmount = BigInt(priceOption?.specialPriceAmount ?? price);
	const specialPriceValue = priceOption?.specialPriceValue ?? null;

	const menuItemCardPricing = {
		price,
		specialPriceAmount,
		specialPriceValue,
		specialPriceIsPercent: priceOption?.specialPriceIsPercent ?? true,
		showPromotion: !!specialPriceValue && specialPriceAmount !== price,
	};
	return  {
		...context,
		viewState: {
			...context.viewState,
			...menuItemCardPricing,
	}}
};

export const homeMenuItemCartRule: HomeMenuItemProcessingRule = context => ({
	...context,
	viewState: {
		...context.viewState,
		cantItemsInCart: context.item?.cantItemsInCart ?? 0,
		totalQtyItemsInCart: context.totalQuantityInCart,
	},
});

export const homeMenuItemQuantityRule: HomeMenuItemProcessingRule = context => ({
	...context,
	viewState: {
		...context.viewState,
		cantidadProducto:
			context.item?.cantidad && context.item.cantidad > 0n ? context.item.cantidad : 1n,
		productInOrder: (context.item?.cantidad ?? 0n) > 0n,
	},
});

export const homeMenuItemStockRule: HomeMenuItemProcessingRule = context => {
	const stock = context.item?.stock ?? null;

	return {
		...context,
		viewState: {
			...context.viewState,
			stock,
			isOutOfStock:
				stock !== null && (stock === 0 || context.totalQuantityInCart >= stock),
		},
	};
};

export const homeQuantityChangeRule: HomeQuantityChangeRule = context => {
	if (context.operation === 1) {
		const canIncrease =
			!context.hasStockTracking || context.totalQuantityInCart < context.stock;

		return canIncrease
			? {
					quantity: context.currentQuantity + 1n,
					isInOrder: true,
					shouldUpdate: true,
				}
			: {
					quantity: context.currentQuantity,
					isInOrder: context.currentQuantity > 0n,
					shouldUpdate: false,
				};
	}

	if (context.currentQuantity <= 1n) {
		return { quantity: context.currentQuantity, isInOrder: false, shouldUpdate: true };
	}

	return {
		quantity: context.currentQuantity - 1n,
		isInOrder: true,
		shouldUpdate: true,
	};
};

export const homeMenuItemModalRule: HomeMenuItemModalRule = item => {
	const hasModifiers = (item?.gruposModificadores?.length ?? 0) > 0;
	const hasMultiplePrices = (getPrimaryProductChannel(item)?.precios?.length ?? 0) > 1;

	return hasModifiers || hasMultiplePrices
		? ModalCssClassEnum.CommonLong
		: ModalCssClassEnum.CommonMedium;
};
